export const AUTH_TOKEN = 'auth-token'

export const GEOCODING_TOKEN = 'AIzaSyBwceg0Bv-mEQlJ_QjSCC2tA4NWKpK23C4'
